import {useNavigate} from 'react-router-dom'
import {useEffect} from 'react'
import api from "../../utils/api";
import {useCommonStore} from "../../hooks/useCommonStore";
import {useAccess} from "../../hooks/useAccess";

const LoginCallback = () => {

  const navigate = useNavigate();
  const {setUserInfo, setIsSignIn} = useCommonStore();
  const {getAccessOptions, selectAccessOption} = useAccess();

  useEffect(() => {
    const getUserInfo = async () => {
      const properties = [
        'name',
        'tribe',
        'church',
        'department',
        'area',
        'cell',
        'adminCenters',
        'userCenters',
        'authLevel',
      ];
      const queryParams=properties.map(property => `properties=${property}`).join('&');
      const userInfo = await api.get(`/v1/users/me?${queryParams}`);

      let authLevel;
      switch (userInfo.authLevel) {
        case 41:
        case 40:
          authLevel = 'HEAD'
          break;
        case 30:
          authLevel = 'TRIBE'
          break;
        case 20:
          authLevel = 'CHURCH'
          break;
        case 10:
          authLevel = 'CENTER_BATCH'
          break;
        default:
          break;
      }

      setUserInfo({
        ...userInfo,
        authLevel,
      });
      setIsSignIn(true);

      const accessOptions = getAccessOptions(userInfo);
      if (accessOptions.length === 1) {
        selectAccessOption(accessOptions[0]);
      }

      navigate('/main');
    }
    getUserInfo();
  }, []);

  return null;
}

export default LoginCallback;
